//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import historyTableConfig from './historyTableConfig';

export default {
  props: {
    value: { type: Boolean, default: false },
    data: { type: Array, default: () => ([]) },
    id: { type: Number, default: 0 },
  },

  data() {
    return {
      historyTableConfig,
    };
  },

  computed: {
    model: {
      get() {
        const { value } = this;
        return value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  methods: {
    classTypeOfInfluence(type) {
      if (type === 'Positive') return 'success--text';
      if (type === 'Negative') return 'error--text';
      return '';
    },

    apply() {
      const { input } = this;
      this.$emit('apply', { input });
    },

    close() {
      this.$emit('close');
    },
  },
};
